import { Box, Tooltip, Typography } from "@mui/material";
import SubTaskIcon from "../assets/action-items/sub-tasks-icon.svg";
import TaskManagementIcon from "../assets/action-items/taskManagement.svg";
import { ActionItemBreadcrumb } from "./types";

export const ActionItemBreadcrumbs = ({
  crumbs,
  currentTitle,
  isSubtask = false,
  onSelect,
}: {
  crumbs: ActionItemBreadcrumb[];
  currentTitle?: string | null;
  isSubtask?: boolean;
  onSelect: (crumb: ActionItemBreadcrumb, index: number) => void;
}) => {
  if (!crumbs.length && !currentTitle) return null;

  const currentTone = "purple";
  const currentIcon = isSubtask ? SubTaskIcon : TaskManagementIcon;

  return (
    <Box className="action-item-breadcrumbs">
      {crumbs.map((crumb, index) => (
        <Box key={`${crumb.id}-${index}`} className="action-item-breadcrumb-item">
          {index > 0 && (
            <span className="nso-breadcrumb__sep">/</span>
          )}
          <img
            src={TaskManagementIcon}
            alt=""
            className="action-item-breadcrumb-icon action-item-breadcrumb-icon--grey"
          />
          <Tooltip title={crumb.title} arrow placement="top">
            <Typography
              className="action-item-breadcrumb-link action-item-breadcrumb--grey"
              onClick={() => onSelect(crumb, index)}
            >
              {crumb.title?.trim() || "Untitled"}
            </Typography>
          </Tooltip>
        </Box>
      ))}
      {currentTitle ? (
        <Box className="action-item-breadcrumb-item">
          {crumbs.length > 0 && (
            <span className="nso-breadcrumb__sep">/</span>
          )}
          <img
            src={currentIcon}
            alt=""
            className={`action-item-breadcrumb-icon action-item-breadcrumb-icon--${currentTone}`}
          />
          <Tooltip title={currentTitle} arrow placement="top">
            <Typography className={`action-item-breadcrumb-current action-item-breadcrumb--${currentTone}`}>
              {currentTitle}
            </Typography>
          </Tooltip>
        </Box>
      ) : null}
    </Box>
  );
};
